import { fromJS } from 'immutable';

import { successAction } from 'actions/actionTypes';
import {
    AUTHENTICATED,
    CLEAR_MFA_CHALLENGE,
    LOGIN,
    VERIFY_MFA,
    VERIFY_MFA_SETUP,
} from 'actions/session';

const defaultState = fromJS({
    status: null,
    session: null,
    email: null,
    secretCode: null,
    otpAuthUri: null,
});

export default function mfa(state = defaultState, action) {
    switch (action.type) {
        case successAction(LOGIN): {
            const { status, session, secretCode, otpAuthUri } = action.response.data;

            if (!status || status === AUTHENTICATED) {
                return defaultState;
            }

            return fromJS({
                status,
                session,
                email: action.email,
                secretCode: secretCode || null,
                otpAuthUri: otpAuthUri || null,
            });
        }
        case CLEAR_MFA_CHALLENGE:
        case successAction(VERIFY_MFA):
        case successAction(VERIFY_MFA_SETUP):
            return defaultState;
        default:
            return state;
    }
}
